"use client"

import { Drone } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `DroneIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const DroneIcon = component(Icon)({ as: Drone })
